import styled from "styled-components";
import { motion } from "framer-motion";

export const GLC_Container = styled(motion.div)`
	width: 220px;
	height: 250px;
	display: grid;
	grid-auto-rows: 1fr;
	gap: 10px;
`;

export const groupLessonCellVariants = {
	hidden: {
		opacity: 0,
		y: 10,
		scale: 0.97,
		filter: "blur(4px)",
	},
	visible: {
		opacity: 1,
		y: 0,
		scale: 1,
		filter: "blur(0px)",
		transition: {
			duration: 0.3,
			ease: [0.16, 1, 0.3, 1],
			staggerChildren: 0.04,
		},
	},
	exit: {
		opacity: 0,
		scale: 0.97,
		filter: "blur(4px)",
		transition: {
			duration: 0.18,
		},
	},
};
